<template>
	<div style="width: 100%;">
		<van-popup class="applyform-content" v-model="applyFormShow" position="bottom" round :style="{ height: '70%' }" :close-on-click-overlay="false">
			<div class="apply-desc" v-if="applyForm.name != null && applyForm.name != ''" style="text-align: center; font-size: 14px; font-weight: bold">
				{{ applyForm.name }}
			</div>
			<div v-if="applyForm.cover != null && applyForm.cover != ''" class="apply-img">
				<img :src="applyForm.cover" alt="" />
			</div>
			<!-- <div class="apply-desc" v-if="applyForm.desc != null && applyForm.desc != ''" style="margin-top: 15px">
				<div v-html="applyForm.desc"></div>
			</div> -->
			<div 
			class="apply-desc" 
				v-if="getPureText(applyForm.desc)" 
				style="margin-top: 15px"
			>
				<div v-html="applyForm.desc"></div>
			</div>
			<van-form @submit="onSubmitApply">
				<van-cell v-for="(item, index) in applyForm.apply_content" :key="index">
					<!-- 输入框（type=1：姓名/电话/区域/意向机型/购买价格） -->
					<van-field 
						v-if="item.type == 1 && !['区域', '意向机型'].includes(item.name)"
						v-model="applyinfo.content[item.name]"
						border 
						:name="item.name" 
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
					/>
					<!-- 区域选择（index=2，type=1） -->
					<van-field
						v-if="item.name == '区域'"
						v-model="applyArea"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
						readonly
						@click="openSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="arrow-down" size="8"/> </template>
					</van-field>
					<!-- 意向机型（index=3，type=1，改为输入框） -->
					<van-field
						v-if="item.name == '意向机型'"
						v-model="applyinfo.content.intention_type"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
					/>
					<!-- 意向购买时间（type=3，时间选择框） -->
					<van-field
						v-if="item.type == 3"
						v-model="applyinfo.content.intention_time"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
						readonly
						@click="openTimeSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="calendar" size="8"/> </template>
					</van-field>
				</van-cell>
				<!-- <van-cell v-for="(item, index) in applyForm.apply_content" :key="index">
					<van-field v-if="index == 0" v-model="applyinfo.content.name" border :name="item.name" :placeholder="item.placeholder" />
					<van-field v-if="index == 1" v-model="applyinfo.content.mobile" border :name="item.name" :placeholder="item.placeholder" />
					<van-field
						v-if="index == 2"
						v-model="applyArea"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						readonly
						@click="openSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="arrow-down" size:="8"/> </template></van-field>
					<van-field
						v-if="index == 3"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						v-model="applyinfo.content.intention_type"
						readonly
						@click="openSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="arrow-down" size:="8"/> </template>
					</van-field>
				</van-cell> -->
				<div style="margin: 16px">
					<van-button class="button">{{ applyForm.submit_zh }}</van-button>
				</div>
			</van-form>
			<div class="buttom">客服代表将尽快与您联系，请保持通讯通畅！</div>
			<div class="applyformdelicon" @click='closeapplyform'><van-icon name="cross" /></div>
		</van-popup>
		<!-- 时间选择弹窗（新增） -->
		<van-popup v-model="showTimeApply" position="bottom">
			<van-datetime-picker
				v-model="currentTime"
				type="date"
				title="选择意向购买时间"
				show-toolbar
				@confirm="onConfirmTime"
				@cancel="showTimeApply = false"
			/>
		</van-popup>
		<van-popup v-model="showAreaApply" position="bottom">
			<van-area :area-list="areaList" @confirm="onConfirmApply" @cancel="showAreaApply = false" />
		</van-popup>
		<van-popup v-model="showSelect" round position="bottom">
			<van-picker title="标题" show-toolbar :columns="columns" @cancel="showSelect = false" @confirm="onConfirmType">
					<template #option="option">
							{{ option.name }}
					</template>
			</van-picker>
		</van-popup>
		<!-- 在线询价tab -->
		<div class="applyform-content" v-if="tabName == '在线报名'">
			<div class="apply-desc" v-if="applyForm.name != null && applyForm.name != ''" style="text-align: center; font-size: 14px; font-weight: bold">
				{{ applyForm.name }}
			</div>
			<div v-if="applyForm.cover != null && applyForm.cover != ''" class="apply-img">
				<img :src="applyForm.cover" alt="" />
			</div>
			<!-- <div class="apply-desc" v-if="applyForm.desc != null && applyForm.desc != ''" style="margin-top: 15px">{{ applyForm.desc }}</div> -->
			<div 
				class="apply-desc" 
				v-if="applyForm.desc != null && applyForm.desc != '' && getPureText(applyForm.desc)" 
				style="margin-top: 15px"
				v-html="applyForm.desc"
			></div>
			<van-form @submit="onSubmitApply">
				<van-cell v-for="(item, index) in applyForm.apply_content" :key="index">
					<!-- 输入框（type=1：姓名/电话/意向机型/购买价格） -->
					<van-field 
						v-if="item.type == 1 && !['区域', '意向机型'].includes(item.name)"
						v-model="applyinfo.content[item.name]"
						border 
						:name="item.name" 
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
					/>
					<!-- 区域选择（index=2） -->
					<van-field
						v-if="item.name == '区域'"
						v-model="applyArea"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
						readonly
						@click="openSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="arrow-down" size="8"/> </template>
					</van-field>
					<!-- 意向机型（index=3，输入框） -->
					<van-field
						v-if="item.name == '意向机型'"
						v-model="applyinfo.content.intention_type"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
					/>
					<!-- 意向购买时间（type=3） -->
					<van-field
						v-if="item.type == 3"
						v-model="applyinfo.content.intention_time"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						:required="item.mandatory == 1"
						readonly
						@click="openTimeSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="calendar" size="8"/> </template>
					</van-field>
				</van-cell>
				<!-- <van-cell v-for="(item, index) in applyForm.apply_content" :key="index">
					<van-field v-if="index == 0" v-model="applyinfo.content.name" border :name="item.name" :placeholder="item.placeholder" />
					<van-field v-if="index == 1" v-model="applyinfo.content.mobile" border :name="item.name" :placeholder="item.placeholder" />
					<van-field v-if="index == 2"
						v-model="applyArea" 
						border 
						:name="item.name" 
						:placeholder="item.placeholder" 
						readonly 
						@click="openSelect(index)">
						<template v-slot:right-icon> <van-icon name="arrow-down" size:="8"/> </template></van-field
					>
					<van-field
						v-if="index == 3"
						border
						:name="item.name"
						:placeholder="item.placeholder"
						v-model="applyinfo.content.intention_type"
						readonly
						@click="openSelect(index)"
					>
						<template v-slot:right-icon> <van-icon name="arrow-down" size:="8"/> </template>
					</van-field>
				</van-cell> -->
				<div style="margin: 16px">
					<van-button class="button">{{ applyForm.submit_zh }}</van-button>
				</div>
			</van-form>
			<div class="buttom">客服代表将尽快与您联系，请保持通讯通畅！</div>
			<van-popup v-model="showAreaApply" position="bottom">
				<van-area :area-list="areaList" @confirm="onConfirmApply" @cancel="showAreaApply = false" />
			</van-popup>
			<van-popup v-model="showSelect" round position="bottom">
				<van-picker title="标题" show-toolbar :columns="columns" @cancel="showSelect = false" @confirm="onConfirmType">
					<template #option="option">
						{{ option.name }}
					</template>
				</van-picker>
			</van-popup>
		</div>
	</div>
</template>
<script>
import * as api from "@/api/live";
import { checkMobile, checkName } from "@/utils/utils.js";
import { areaList } from "@vant/area-data";

export default{
	props:{
		applyFormShow:{
				type: Boolean,
				default: false
		},
		applyForm:{
				type: Object,
				default: ()=> {}
		},
		live_id:{
				type: [String, Number],
				default: ''
		},
		tabName:{
			type: String,
			default: ""
		}
	},
	data(){
		return {
			applyflag:true,
			applyinfo: {
				content: {
					// name: "",
					// mobile: "",
					province: "",      // 省份
					city: "",          // 城市
					area: "",          // 区域
					intention_type: "",// 意向机型
					"意向购买价格": "", // 意向购买价格（选填）
					intention_time: "" // 意向购买时间
				}
			},
			applyArea: '',
			areaList,
			showAreaApply: false,
			columns: '',
			showSelect: false,
			showTimeApply: false,
      currentTime: new Date()
		}
	},
  methods: {
		// 新增：提取纯文本并过滤空标签
		getPureText(htmlStr) {
			if (!htmlStr) return '';
			
			// 1. 创建临时DOM元素解析HTML
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = htmlStr;
			
			// 2. 获取纯文本并去除所有空白字符（空格、换行、制表符等）
			const pureText = tempDiv.textContent || tempDiv.innerText || '';
			const trimmedText = pureText.replace(/\s+/g, '');
			
			// 3. 返回处理后的纯文本（非空则返回文本，空则返回''）
			return trimmedText;
		},
    //打开报名表选择框
		openSelect(index) {
			if (this.applyForm.apply_content[index].name == '区域') {
				this.showAreaApply = true;
			}
    },
		// 打开时间选择框（新增）
		openTimeSelect(index) {
				this.showTimeApply = true;
		},
		closeapplyform(){
				this.$emit("update:applyFormShow", false)
		},
		// 确认意向购买时间（新增）
		onConfirmTime(val) {
			// 格式化时间为 YYYY-MM-DD
			const time = new Date(val)
			const year = time.getFullYear()
			const month = (time.getMonth() + 1).toString().padStart(2, '0')
			const day = time.getDate().toString().padStart(2, '0')
			// const hour = time.getHours().toString().padStart(2, '0')
			// const minute = time.getMinutes().toString().padStart(2, '0')
			this.applyinfo.content.intention_time = `${year}-${month}-${day}`
			this.showTimeApply = false
		},
		//确认报名表意向机型
		onConfirmType(values) {
			this.applyinfo.content.intention_type = values.name
			this.showSelect = false
		},
		// 弹框提示
		fntips(text){
			this.$toast({
					message: `<div style="height:40px;display:flex;align-items:center;justified-content:center">${text}</div>`,
					type: 'html'
			})
		},
    //确认报名表地区
		onConfirmApply(values) {
			this.applyArea = values
				.filter((item) => !!item)
				.map((item) => item.name)
				.join("/");
			this.applyinfo.content.province = values[0].name;
			this.applyinfo.content.city = values[1].name;
			this.applyinfo.content.area = values[2].name;
			this.showAreaApply = false;
		},
    // 提交报名表
    onSubmitApply() {
			if(!this.applyflag){
				return false
			}
			const fieldMap = {
				'姓名': 'name',
				'电话': 'mobile',
				'手机号': 'mobile',
				'区域': 'area',
				'意向机型': 'intention_type',
				'意向购买时间': 'intention_time',
				'意向购买价格': 'intention_price'
			}
			// 遍历apply_content，动态校验必填项
			let requiredError = '';
			this.applyForm.apply_content.forEach(item => {
				if (item.mandatory !== 1 || requiredError) return; // 跳过选填/已找到错误
				// 不同字段的取值逻辑
				let value = '';
				switch(item.name) {
					case '区域':
						value = this.applyArea;
						break;
					case '意向购买时间':
						value = this.applyinfo.content.intention_time;
						break;
					case '意向机型':
						value = this.applyinfo.content.intention_type;
						break;
					default:
						// 姓名/手机号等直接取content中的值
						value = this.applyinfo.content[item.name] || '';
				}
				if (!value || !value.trim()) {
					requiredError = item.name;
				}
			})
			// 提示第一个未填写的必填项
			console.log('requiredError', requiredError)
			if (requiredError) {
				this.fntips(`请填写${requiredError}`);
				return;
			}
			// 先找到姓名/手机号的配置项，判断是否必填
			const nameItem = this.applyForm.apply_content.find(item => item.name === '姓名');
			const mobileItem = this.applyForm.apply_content.find(item => 
				item.name === '手机号' || item.name === '电话'
			);

			// 提取实际的姓名和手机号值
			const realName = this.applyinfo.content['姓名'] || '';
			const realMobile = this.applyinfo.content['电话'] || this.applyinfo.content['手机号'] || '';

			// 姓名格式校验（有值时才校验）
			if (nameItem?.mandatory === 1 && realName) {
				if (!checkName(realName)) {
					this.fntips("请填写2-6位汉字姓名");
					return;
				}
			}
			console.log('真实姓名', realName)
			// if (this.applyForm.apply_content[0].mandatory == 1 && this.applyinfo.content.name == "") {
      //           this.fntips("请填写姓名")
			// 	return;
			// }
			// if (this.applyinfo.content.name != "" && !checkName(this.applyinfo.content.name)) {
      //           this.fntips("请填写2-6位汉字姓名")
			// 	return;
			// }
			// 手机号格式校验（有值时才校验）
			if (mobileItem?.mandatory === 1 && realMobile) {
				if (!checkMobile(realMobile)) {
					this.fntips("请填写正确手机号");
					return;
				}
			}
			console.log('真实手机号', realMobile)
			console.log('this.applyinfo',this.applyinfo)
			// if (this.applyForm.apply_content[1].mandatory == 1 && this.applyinfo.content.mobile == "") {
      //           this.fntips("请填写手机号")
			// 	return;
			// }

			// if (this.applyinfo.content.mobile != "" && !checkMobile(this.applyinfo.content.mobile)) {
      //           this.fntips("请填写正确手机号")
			// 	return;
			// }

			// if (this.applyForm.apply_content[2]) {
			// 	if (this.applyForm.apply_content[2].mandatory == 1 && this.applyArea == "") {
      //               this.fntips("请选择地区")
			// 		return;
			// 	}
			// }

			// if (this.applyForm.apply_content[3]) {
			// 	if (this.applyForm.apply_content[3].mandatory == 1 && this.applyinfo.content.intention_type == "") {
      //               this.fntips("请选择商品型号")
			// 		return;
			// 	}
			// }

			const submitData = {
				live_id: this.live_id,
				apply_id: this.applyForm.id,
				mobile: realMobile,
				nick_name: realName,
				content: {
					// 基础字段
					name: realName,
					mobile: realMobile,
					province: this.applyinfo.content.province,
					city: this.applyinfo.content.city,
					area: this.applyinfo.content.area,
					// 核心修复：提交意向机型
					intention_type: this.applyinfo.content.intention_type,
					// 其他字段
					// "意向购买价格": this.applyinfo.content["意向购买价格"],
					intention_price: this.applyinfo.content["意向购买价格"],
					intention_time: this.applyinfo.content.intention_time,
					// ...this.applyinfo.content
				}
			};

			console.log('提交数据submitData',submitData)

			// this.applyinfo.live_id = this.live_id;
			// this.applyinfo.apply_id = this.applyForm.id;
			// this.applyinfo.mobile = this.applyinfo.content.mobile
			// this.applyinfo.nick_name = this.applyinfo.content.name
			// // 新增购买价格和时间字段
			// this.applyinfo.content.price = this.applyinfo.content["意向购买价格"];
			// this.applyinfo.content.buy_time = this.applyinfo.content.intention_time;

			this.applyflag = false

			api.goodsApply(submitData).then((res) => {
				console.log('报名接口数据', res);
				if (res.code === 200) {
					this.$toast.success("预约成功");
					this.closeapplyform()

					this.applyinfo = {
						content: {
							province: "",
							city: "",
							area: "",
							intention_type: "",
							"意向购买价格": "",
							intention_time: ""
						},
					};
					// 清空动态生成的字段（姓名/电话等）
					this.applyForm.apply_content.forEach(item => {
						if (['姓名', '电话', '手机号'].includes(item.name)) {
							this.applyinfo.content[item.name] = '';
						}
					});
					this.applyArea = "";
					this.applyflag = true
				} else {
					this.$toast(res.message);
					this.applyflag = true
				}
			}).catch(() => {
				this.applyflag = true
			});
		},
    }
}
</script>
<style lang="less" scoped>
	.askpricevlog.van-dialog{
			overflow: visible!important;
	}
	.applyform-content {
		box-sizing: border-box;
		padding: 20px 10px 28px 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.applyformdelicon{
				position: absolute;
				border: 1px solid #fff;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 0.8rem;
				width: 0.8rem;
				right: 0;
				top: 0;
				i{
						font-size: 26px;
						right: .2rem;
						top: .2rem;
				}
		}
		.title {
				font-size: 18px;
		}
		.apply-desc {
				width: 300px;
				text-align: left;
				line-height: 20px;
		}
		.apply-img {
				margin-top: 10px;
				width: 300px;
				height: 110px;
				img {
						width: 100%;
						height: 100%;
				}
		}
		.good-desc {
				margin-top: 15px;
				display: flex;
				height: 90px;
				align-items: center;
				.good-img {
						width: 110px;
						height: 90px;
						img {
								width: 100%;
								height: 100%;
						}
				}
				.good-name {
						margin-left: 10px;
						text-align: left;
						display: flex;
						flex-direction: column;
				}
		}
		.van-cell {
				display: flex;
				align-items: center;
		}
		.van-field {
				border: 1px solid #eee;
				border-radius: 6px;
		}
		.button {
				margin-top: 25px;
				font-weight: 550;
				width: 100%;
				background-color: #1ab4ec;
				color: white;
				height: 35px;
				line-height: 35px;
		}
		.buttom {
				font-size: 12px;
				color: #bbb;
		}
		.van-cell::after {
				display: none;
		}
		.van-field {
				border: 1px solid #eee;
				width: 300px;
		}
	}
</style>